import WebDesigner from "../WebDesigner";
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import store from "app/store";
import { AsyncAjaxPost } from "components/Common/AsyncAjaxService";
import Loader from "components/Common/Loader";
import { useEffect, useState } from "react";
import { LoginUserType } from "utils/Utils";

export default function ConnectDomainClickAd( {designer,DomainNotPurcheshed}:{designer?:WebDesigner,DomainNotPurcheshed?:boolean}){
  const { ReactUserID, CountryID, BuildInDomain, VagaroURL, AmplitudeBusinessID } =  store.getState().Business;
  const { access_token } = store.getState().Token;
  const [isLoading, setLoading] = useState(false);
  const Check =()=>{
      return <div  className="center-all" style={{borderRadius:"50px",height:"22px",width:"22px", background:"#3E8438",padding:"4px",position:"absolute",top:"-4px",right:"-6px"}}>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" viewBox="0 0 15 11" fill="none">
          <path d="M11.4325 0.238281L14.3142 2.56063L7.11783 10.8165L0.5 5.88178L2.80423 3.02483L6.56119 5.82645L11.4325 0.238281Z" fill="#EFF2F9"/>
          </svg>
      </div>
  }

  const DesinerLogo =()=>{
      return <div className="hire-desinger-icons">
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" fill="none">
        <path d="M30.375 0.5C31.2891 0.5 32.0625 1.27344 32.0625 2.1875V4.4375H34.3125C35.2266 4.4375 36 5.21094 36 6.125C36 7.10938 35.2266 7.8125 34.3125 7.8125H32.0625V10.0625C32.0625 11.0469 31.2891 11.75 30.375 11.75C29.3906 11.75 28.6875 11.0469 28.6875 10.0625V7.8125H26.4375C25.4531 7.8125 24.75 7.10938 24.75 6.125C24.75 5.21094 25.4531 4.4375 26.4375 4.4375H28.6875V2.1875C28.6875 1.27344 29.3906 0.5 30.375 0.5ZM35.0156 17.0234C35.5781 17.3047 36 17.8672 36 18.5C36 19.2031 35.5781 19.7656 35.0156 20.0469L19.6172 27.1484C18.5625 27.6406 17.3672 27.6406 16.3125 27.1484L0.914062 20.0469C0.351562 19.7656 0 19.2031 0 18.5C0 17.8672 0.351562 17.3047 0.914062 17.0234L16.3125 9.92188C17.3672 9.42969 18.5625 9.42969 19.6172 9.92188L35.0156 17.0234ZM20.5312 29.1875L31.2188 24.2656L35.0156 26.0234C35.5781 26.3047 36 26.8672 36 27.5C36 28.2031 35.5781 28.7656 35.0156 29.0469L19.6172 36.1484C18.5625 36.6406 17.3672 36.6406 16.3125 36.1484L0.914062 29.0469C0.351562 28.7656 0 28.2031 0 27.5C0 26.8672 0.351562 26.3047 0.914062 26.0234L4.71094 24.2656L15.3984 29.1875C17.0156 29.9609 18.9141 29.9609 20.5312 29.1875Z" fill="white"/>
      </svg>
      </div>
  }

  const Icon = () => {
    return (
      <div className="center-all" style={{fontSize:"12px", textAlign: "center",marginBottom:"8px" }}>
        <div
          className="relative"
          style={{
            borderRadius: "100px",
            padding: "8px 16px",
            color:"#FCD34D",
            border: "1px solid #FCD34D",
          }}
        >
          www.business.com
          <Check/>
        </div>
      </div>
    );
  };

  const openLink = ()=>{

    if(designer){
      designer.onDeselectMenu();
        designer.openSettingsMenu();
        setTimeout(()=>{
        designer.openToDomainSettings()},10);
    }
  }
  const GetStarted = async () => {
    var logobject = {
      PageURL:window.location.href,
      Step:28,
      UserAgent:(navigator.userAgent).toLowerCase(),
      UserID:ReactUserID,
      BusinessID:AmplitudeBusinessID,
      MySiteURL:BuildInDomain + "/" + VagaroURL,
      CountryID:CountryID
    };
    await GetAddLogInAmplitude(logobject);
  };
  const GetAddLogInAmplitude = async (logobject:any) => {
  setLoading(true);
  const Requestdata = {
  PageURL: logobject.PageURL,
  Step: logobject.Step,
  UserAgent: logobject.UserAgent,
  UserID: logobject.UserID,
  BusinessID: logobject.BusinessID,
  MySiteURL: logobject.MySiteURL,
  CountryID: logobject.CountryID,
  };
  await AsyncAjaxPost(
    "amplitude/addloginamplitude",
      Requestdata,
      access_token,
      function onSuccess(data:any) {
          try {
                if (data != null && data.data != null && data.data.data != null) {
                    setLoading(false);
                    window.location.href = "/admin/designservicepage"
                }
                else {
                    setLoading(false);
                    window.location.href = "/admin/designservicepage"
                }
          } catch (error) {
                console.log("error");
                setLoading(false);
                window.location.href = "/admin/designservicepage"
          }
      },
      function OnError() {
          console.log("error");
      }
  );
  }
  
  useEffect(() => {
    
    if(!designer||!designer.state||!designer.state.siteData|| designer.state.siteData.userContext.userType != LoginUserType.VagaroAdmin){

    const numberOfItems = document.getElementsByClassName("carousel-item").length;
    const indicators = document.getElementsByClassName("carousel-indicators")[0];
    const Buttons = indicators.getElementsByTagName("button");

    if (numberOfItems <= 1) {
    for (let i = 0; i < Buttons.length; i++) {
      const indicator = Buttons[i] as HTMLElement;
      indicator.style.display = "none";
    }
    } else {
      for (let i = 0; i < Buttons.length; i++) {
        const indicator = Buttons[i] as HTMLElement;
        indicator.style.display = "block";
      }
    }
  }
    
  }, [DomainNotPurcheshed,designer])
  

  if(designer&&designer.state&&designer.state.siteData&& designer.state.siteData.userContext.userType == LoginUserType.VagaroAdmin)
    return null;

    return <>
    {isLoading && <Loader />}
     <Carousel className="custom-carousel">
      {DomainNotPurcheshed === true && 
        <Carousel.Item>
        <div onClick={()=>{openLink()}} className="hover-sibling" style={{position:"fixed",bottom:"60px",left:"0px",width:"184px",cursor:"pointer", padding:"16px",color:"#eee",background:"#333",margin:"8px",borderRadius:"8px"}} >
          <Icon/>
          <div style={{fontSize:"15px",lineHeight:"20px",marginBottom:"8px"}}>Connect Your Domain</div>
          <p style={{fontSize:"12px",lineHeight:"16px"}}>Purchase a new domain here or connect an existing domain you own.</p>
          <button className="invisible-button w-full" style={{fontWeight:500,padding:"10px 16px",borderRadius:"4px",background:"#eee",color:"#333"}}>Set Up Domain</button>
          </div>


          <div onClick={()=>{openLink()}} className="hover-transparency" style={{position:"fixed",bottom:"60px",left:"0px",width:"184px",cursor:"pointer", padding:"16px",color:"#eee",zIndex:"100",background:"#333",margin:"8px",borderRadius:"8px"}} >
          <Icon/>
          <div style={{fontSize:"15px",lineHeight:"20px",marginBottom:"8px"}}>Connect Your Domain</div>
          <p style={{fontSize:"12px",lineHeight:"16px"}}>Purchase a new domain here or connect an existing domain you own.</p>
          <button className="invisible-button w-full" style={{fontWeight:500,padding:"10px 16px",borderRadius:"4px",background:"#eee",color:"#333"}}>Set Up Domain</button>
          </div>
        
        </Carousel.Item>
      }
      <Carousel.Item>
      <div onClick={() => GetStarted()} className="tab-link hover-sibling red-logo-card" style={{position:"fixed",bottom:"60px",left:"0px",width:"184px",cursor:"pointer", padding:"16px",color:"#fff",background:"rgb(255 75 75)",margin:"8px",borderRadius:"8px"}} >
        <DesinerLogo/>
        <div className="tab-link" style={{fontSize:"15px",lineHeight:"20px",marginBottom:"4px",fontWeight:"500",background:"rgb(255, 75, 75)"}}>Hire a Website Designer</div>
        <p className="tab-link"style={{fontSize:"12px",lineHeight:"16px",marginBottom:"8px",fontWeight:"400",background:"rgb(255, 75, 75)"}}>Need help building a custom website or transferring your existing one? Our Website Designers can handle that for you!</p>
        <button className="tab-link invisible-button w-full" style={{fontWeight:500,padding:"10px 16px",borderRadius:"4px",background:"#eee",color:"#333"}}>Get Started</button>
        </div>


        <div onClick={() => GetStarted()} className="tab-link hover-transparency red-logo-card" style={{position:"fixed",bottom:"60px",left:"0px",width:"184px",cursor:"pointer", padding:"16px",zIndex:"100",color:"#fff",background:"rgb(255 75 75)",margin:"8px",borderRadius:"8px"}} >
        <DesinerLogo/>
        <div className="tab-link" style={{fontSize:"15px",lineHeight:"20px",marginBottom:"4px",fontWeight:"500",background:"rgb(255, 75, 75)"}}>Hire a Website Designer</div>
        <p className="tab-link" style={{fontSize:"12px",lineHeight:"16px",marginBottom:"8px",fontWeight:"400",background:"rgb(255, 75, 75)"}}>Need help building a custom website or transferring your existing one? Our Website Designers can handle that for you!</p>
        <button className="tab-link invisible-button w-full" style={{fontWeight:500,padding:"10px 16px",borderRadius:"4px",background:"#eee",color:"#333"}}>Get Started</button>
        </div>
      </Carousel.Item>
    </Carousel>
    
    </>

}